import { Schema as S } from "effect";
import { defineMessageUnion } from "foldkit/message";

import { getAiPreferences } from "../../api/commands/ai";
import * as AiChat from "../../widgets/aiChat";

export const Message = defineMessageUnion({
	GotChatMessage: { message: AiChat.Message },
	CompletedFetchAi: { generation: S.Number, result: getAiPreferences.Result },
});
export type Message = typeof Message.Type;
